/* src/app/components/leads/dynamic-form-renderer/dynamic-form-renderer.component.css */
.dynamic-form-container {
  padding: 0;
}
.form-banner {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1890ff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.form-banner:has(.form-header-actions:empty),
.form-banner:not(:has(.form-header-actions)) {
  justify-content: flex-start;
}
.form-banner h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #163235;
  margin: 0;
  flex: 1;
}
.form-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.completed-status-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.completed-badge-header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #52c41a;
  padding: 6px 12px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  white-space: nowrap;
}
.form-description {
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f0f7ff;
  border-left: 4px solid #1890ff;
  border-radius: 4px;
}
.form-description p {
  margin: 0;
  color: #555;
  line-height: 1.6;
  font-size: 14px;
}
.dynamic-form {
  margin-top: 16px;
}
.form-section {
  margin-bottom: 32px;
}
.form-section:last-of-type {
  margin-bottom: 16px;
}
.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #163235;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}
.section-description {
  margin-bottom: 16px;
  color: #666;
  font-style: italic;
  font-size: 13px;
}
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 8px 0;
}
.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-field label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}
.required {
  color: #ff4d4f;
  margin-left: 4px;
}
.form-field.field-gated-off label,
.form-field.field-gated-off legend {
  color: #bfbfbf;
}
.form-field.field-gated-off .required {
  display: none;
}
.field-description {
  color: #999;
  font-size: 12px;
  line-height: 1.5;
  margin-top: -4px;
}
.option-description {
  display: block;
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  margin-left: 4px;
  margin-top: 2px;
}
.error-message {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
}
.field-note {
  color: #595959;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
  font-style: italic;
}
.calculated-field {
  background-color: #f0f7ff;
  font-weight: 600;
  color: #163235;
  opacity: 1;
  border-color: #bcdcff;
}
::ng-deep .dynamic-form input.calculated-field.ant-input-disabled,
::ng-deep .dynamic-form input.calculated-field:disabled {
  color: #163235 !important;
  -webkit-text-fill-color: #163235;
  opacity: 1 !important;
  background-color: #f0f7ff !important;
  border-color: #bcdcff !important;
  cursor: default;
}
.form-field.field-hidden {
  display: none;
}
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.checkbox-group label {
  margin: 0;
}
nz-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
nz-radio-group label {
  margin: 0;
}
nz-alert {
  margin-bottom: 16px;
}
.table-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.dynamic-table-wrapper {
  overflow-x: auto;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.dynamic-table-wrapper::-webkit-scrollbar {
  height: 8px;
}
.dynamic-table-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
.dynamic-table-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
.dynamic-table-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 10px;
}
.dynamic-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1080px;
  table-layout: fixed;
}
.dynamic-table td nz-select,
.dynamic-table td input,
.dynamic-table td textarea {
  width: 100%;
  font-size: 13px;
}
.dynamic-table th,
.dynamic-table td {
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid #f0f0f0;
}
.dynamic-table td .cell-readonly {
  display: block;
  padding-top: 5px;
  overflow-wrap: anywhere;
  font-size: 13px;
  font-weight: 400;
}
.dynamic-table thead th {
  background: #fafafa;
  font-weight: 600;
  font-size: 13px;
  color: #333;
  white-space: normal;
}
.dynamic-table tbody tr:last-child th,
.dynamic-table tbody tr:last-child td {
  border-bottom: none;
}
.dynamic-table tbody th.row-number-col {
  font-weight: 600;
  color: #666;
  font-size: 13px;
  padding-top: 14px;
}
.dynamic-table .row-number-col {
  width: 44px;
  text-align: center;
}
.dynamic-table .row-actions-col {
  width: 88px;
  text-align: center;
}
.row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.row-action-symbol {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  font-size: 15px;
  line-height: 1;
  color: #1890ff;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
}
.row-action-symbol:hover:not(:disabled) {
  background: #e6f7ff;
  border-color: #91d5ff;
}
.row-action-symbol.row-action-remove {
  color: #ff4d4f;
}
.row-action-symbol.row-action-remove:hover:not(:disabled) {
  background: #fff1f0;
  border-color: #ffa39e;
}
.row-action-symbol:disabled {
  color: #d9d9d9;
  cursor: not-allowed;
}
.table-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}
.table-add-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #1890ff;
  background: transparent;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  cursor: pointer;
}
.table-add-row:hover:not(:disabled) {
  background: #e6f7ff;
}
.table-add-row:disabled {
  color: #bfbfbf;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.table-row-count {
  color: #999;
  font-size: 12px;
}
.sr-announcements {
  position: relative;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.dynamic-form input:focus,
.dynamic-form textarea:focus,
.dynamic-form select:focus,
.dynamic-form button:focus {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.2);
}
.dynamic-form input[type=radio]:focus,
.dynamic-form input[type=checkbox]:focus {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
}
::ng-deep .ant-input:focus,
::ng-deep .ant-input-number:focus,
::ng-deep .ant-select-focused .ant-select-selector,
::ng-deep .ant-picker-focused {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.2) !important;
  border-color: #1890ff !important;
}
::ng-deep .ant-radio-wrapper:focus-within,
::ng-deep .ant-checkbox-wrapper:focus-within {
  outline: 2px dashed #1890ff;
  outline-offset: 2px;
}
.dynamic-form input:disabled,
.dynamic-form textarea:disabled,
.dynamic-form select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f5f5f5;
}
::ng-deep .dynamic-form .ant-input-disabled,
::ng-deep .dynamic-form .ant-input-number-disabled,
::ng-deep .dynamic-form .ant-picker-disabled,
::ng-deep .dynamic-form .ant-select-disabled .ant-select-selector {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f5f5f5 !important;
}
::ng-deep .dynamic-form .ant-radio-wrapper-disabled,
::ng-deep .dynamic-form .ant-checkbox-wrapper-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.45);
}
::ng-deep .dynamic-form .ant-radio-wrapper-disabled .ant-radio,
::ng-deep .dynamic-form .ant-checkbox-wrapper-disabled .ant-checkbox {
  cursor: not-allowed;
}
@media (prefers-contrast: high) {
  .form-field label {
    font-weight: 700;
  }
  .error-message {
    font-weight: 600;
    text-decoration: underline;
  }
  .required {
    font-weight: 700;
    font-size: 1.2em;
  }
  .dynamic-form input:focus,
  .dynamic-form textarea:focus,
  .dynamic-form select:focus {
    outline-width: 3px;
  }
}
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
.dynamic-form input:focus:not(:focus-visible),
.dynamic-form textarea:focus:not(:focus-visible),
.dynamic-form select:focus:not(:focus-visible),
.dynamic-form button:focus:not(:focus-visible) {
  outline: none;
  box-shadow: none;
}
.dynamic-form input:focus-visible,
.dynamic-form textarea:focus-visible,
.dynamic-form select:focus-visible,
.dynamic-form button:focus-visible {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.2);
}
.required::before {
  content: "";
  display: inline-block;
}
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}
fieldset legend {
  font-weight: 500;
  color: #333;
  font-size: 14px;
  padding: 0;
  margin-bottom: 8px;
}
.form-field:has(.error-message) input,
.form-field:has(.error-message) textarea,
.form-field:has(.error-message) select {
  border-color: #ff4d4f;
}
.error-message[role=alert] {
  font-weight: 500;
}
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #1890ff;
  color: white;
  padding: 8px;
  text-decoration: none;
  z-index: 100;
}
.skip-link:focus {
  top: 0;
}
@media (max-width: 768px) {
  .dynamic-form-container {
    padding: 0;
  }
  .form-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .form-banner h2 {
    font-size: 1.25rem;
  }
  .form-header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .completed-status-header {
    width: 100%;
    justify-content: space-between;
  }
  .completed-badge-header {
    font-size: 0.8125rem;
    padding: 5px 10px;
  }
  .section-title {
    font-size: 1rem;
  }
  .form-description {
    padding: 10px 12px;
  }
  .form-fields {
    gap: 16px;
  }
  .form-section {
    margin-bottom: 24px;
  }
  .dynamic-table .row-actions-col {
    width: 88px;
  }
  .dynamic-form input,
  .dynamic-form textarea,
  .dynamic-form select,
  .dynamic-form button {
    min-height: 44px;
  }
}
/*# sourceMappingURL=dynamic-form-renderer.component-WZG6RMZO.css.map */
